/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dept', {
            parent: 'entity',
            url: '/dept?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dept.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dept/depts.html',
                    controller: 'DeptController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dept-detail', {
            parent: 'dept',
            url: '/dept/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dept.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dept/dept-detail.html',
                    controller: 'DeptDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dept', function($stateParams, Dept) {
                    return Dept.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dept',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dept-detail.edit', {
            parent: 'dept-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dept.new', {
            parent: 'dept',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reference: null,
                                date: null,
                                amount: null,
                                comment: null,
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('dept');
                });
            }]
        })
        .state('dept.edit', {
            parent: 'dept',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dept.delete', {
            parent: 'dept',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-delete-dialog.html',
                    controller: 'DeptDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
